import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { ProjectNotificationsOverrideStatus } from '../../fragments/generated/ProjectNotificationsOverrideStatus';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetProjectNotificationOverrideStatusQueryVariables = Types.Exact<{
  accountId: Types.Scalars['ID']['input'];
  projectId: Types.Scalars['ID']['input'];
}>;


export type GetProjectNotificationOverrideStatusQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, project?: { __typename?: 'Project', id: string, hasProjectNotificationsOverride?: boolean | null } | null } | null };


export const GetProjectNotificationOverrideStatus = /*#__PURE__*/ gql`
    query GetProjectNotificationOverrideStatus($accountId: ID!, $projectId: ID!) {
  account(by: {id: $accountId}) {
    id
    project(id: $projectId) {
      ...ProjectNotificationsOverrideStatus
    }
  }
}
    ${ProjectNotificationsOverrideStatus}` as unknown as DocumentNode<GetProjectNotificationOverrideStatusQuery, GetProjectNotificationOverrideStatusQueryVariables>;

          

          export const useGetProjectNotificationOverrideStatusQuery = (options?:QueryHookOptions<GetProjectNotificationOverrideStatusQuery, GetProjectNotificationOverrideStatusQueryVariables>) => useQuery(GetProjectNotificationOverrideStatus, options);

          

          export type GetProjectNotificationOverrideStatusQueryOptions = QueryHookOptions<GetProjectNotificationOverrideStatusQuery, GetProjectNotificationOverrideStatusQueryVariables>;

          

          export const useGetProjectNotificationOverrideStatusLazyQuery = (options?:LazyQueryHookOptions<GetProjectNotificationOverrideStatusQuery, GetProjectNotificationOverrideStatusQueryVariables>) => useLazyQuery(GetProjectNotificationOverrideStatus, options);

          

          export type GetProjectNotificationOverrideStatusQueryResult = ReturnType<typeof useGetProjectNotificationOverrideStatusQuery>;

          
